"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsInBannerByGeo = void 0;
exports.paymentsInBannerByGeo = {
    GB: ['changelly_crypto', 'tp_ob_uk', 'pa_cascade', 'flexpay'],
    DE: ['changelly_crypto', 'pg_ob_de', 'pa_cascade', 'pg_ob_de2'],
    AT: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    CH: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    NL: ['pg_ob_ideal', 'changelly_crypto', 'pa_cascade', 'pg_ob'],
    GR: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    AU: ['changelly_crypto', 'binance_payin', 'payler_payid', 'pa_cascade'],
    NZ: ['changelly_crypto', 'binance_payin', 'pa_cascade', 'neosurf'],
    SE: [
        'changelly_crypto',
        'pa_cascade',
        'billblend_applepay',
        'billblend_googlepay',
    ],
    RU: ['changelly_crypto'],
    CA: ['changelly_crypto', 'binance_payin', 'neosurf_apm_eur'],
    DK: ['changelly_crypto', 'pa_cascade', 'flexpay', 'billblend_applepay'],
    IT: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    FI: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    FR: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    IE: ['changelly_crypto', 'pa_cascade', 'pg_ob', 'billblend_applepay'],
    PL: ['ph_blik', 'changelly_crypto', 'pa_cascade', 'pg_ob'],
    NO: ['changelly_crypto', 'pa_cascade', 'flexpay', 'billblend_applepay'],
};
